import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Search } from "lucide-react";

export function HeroSection({
  query,
  setQuery,
  onAnalyze,
}: {
  query: string;
  setQuery: (v: string) => void;
  onAnalyze: () => void;
}) {
  return (
    <section className="pt-8 pb-10 text-center">
      <motion.h1
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="text-[28px] font-semibold tracking-tight"
      >
        Your Personal Financial Advisor
      </motion.h1>

      <div className="mt-5 flex justify-center">
        <div className="relative w-[620px]">
          <div className="absolute -inset-[1px] rounded-full bg-gradient-to-r from-cyan-500/50 via-blue-500/40 to-purple-500/35 blur-[0.5px]" />
          <div className="relative flex items-center gap-3 rounded-full border border-white/15 bg-[#07081d]/70 px-4 py-2 shadow-[0_14px_40px_-24px_rgba(0,0,0,0.85)]">
            <Search className="h-4 w-4 text-white/55" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onAnalyze();
              }}
              placeholder="Try using K-Quant to deeply analyze and interpret financial News"
              className="h-7 w-full bg-transparent text-sm text-white/80 placeholder:text-white/45 outline-none"
            />
            <button
              onClick={onAnalyze}
              className="grid h-7 w-7 place-items-center rounded-full bg-gradient-to-r from-cyan-500/80 to-blue-500/80 shadow-[0_10px_25px_-18px_rgba(34,211,238,0.85)] hover:from-cyan-400/90 hover:to-blue-400/90"
              aria-label="Analyze"
            >
              <ArrowUpRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 text-xs text-white/55">
        <span className="inline-flex items-center gap-1">
          <span className="inline-block h-4 w-4 rounded-full border border-white/10 bg-white/5" />
          Recommend:
        </span>
        <span className="text-white/60">
          Stock/ETF/Index/Mutual Funds/Cryptocurrencies/Futures
        </span>
      </div>
    </section>
  );
}
